/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.treebrowse.js" />
(
    function (skyward, $, undefined) {
        var minimumContent = 50;
        var maxContentHeight = 125;
        var maxContentHeightPX = maxContentHeight + 'px';
        var insertColumnDiv = [];
        var treeGridDiv = [];
        var maxWindowHeight = $(window).height() * .8;

        skyward.authenticationmethod = skyward.authenticationmethod || {};

        var defaultSettings =
            {
                title: "Insert Field",
                onFieldSelect: function () { },
                onCancel: function () { }
            };

        var init = function (selector) { };

        skyward.authenticationmethod.popInsertNameIdentifierSkywardField = function (button) {
            var container = $(button).parents(".authenticationMethodWrapper");
            var dataModule = "Security";
            var dataObject = "User";
            var clickedElement = $(this);

            var options =
                {
                    anchorTo: clickedElement,
                    beforeClose: preCloseInsertColumnMenu,
                    onFieldSelect: function (field) { insertField(container, field); }
                };

            skyward.authenticationmethod.openSelectFieldDialog(dataModule, dataObject, options);
        };

        var preCloseInsertColumnMenu = function () {
            insertColumnDiv = [];
            treeGridDiv = [];
        };

        var insertField = function (container, field) {
            var controlToUpdate = container.find(".NameIdentifierSkywardField");
            document.getElementById("NameIdentifierSkywardFieldFriendlyName").value = "";
            skyward.global.text.insertTextToken(controlToUpdate, field, true);
        };

        skyward.authenticationmethod.openSelectFieldDialog = function (module, object, options) {
            var settings = $.extend({}, defaultSettings, options);
            var selectFieldDialog;

            var onSaveClick = function () {
                var field = getFieldFromTree(selectFieldDialog, settings);
                selectFieldDialog.close();
                settings.onFieldSelect(field);
            };
            var onCancelClick = function () {
                selectFieldDialog.close();
                settings.onCancel();
            };

            var saveButton = { text: "Save", "click": onSaveClick, "icon": "Save" };
            var cancelButton = { text: "Cancel", "click": onCancelClick, "icon": "Cancel" };

            selectFieldDialog = skyward.modalLayer.showDialog(settings.title, function () { return buildTreePopup(module, object, settings); }, [saveButton, cancelButton], settings);
            selectFieldDialog.content.on("treeBrowseSave", onSaveClick);
        };

        var buildTreePopup = function (module, object, options) {
            return $.ajax({
                url: skyward.global.virtualDir + "Security/User/BuildTreeBrowseForAuthMethodAdd/",
                type: "POST",
                dataType: "viewparthtml",
                data:
                    {
                        module: module,
                        object: object
                    }
            });
        };

        var getFieldFromTree = function (modalLayer, options) {
            var fieldData = skyward.treebrowse.getSelectedFieldData(modalLayer.content);

            if (!fieldData || !fieldData.fieldName || !fieldData.fieldType || fieldData.fieldType.toString() === "ManyToOne") {
                return "";
            }

            var fieldPath = fieldData.fieldName;
            if (fieldPath.startsWith("User.")) {
                fieldPath = fieldPath.slice(5);
            }

            return fieldPath;

        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);